// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Result = require("@rescript/core/src/Core__Result.bs.js");

function makeSingleFamilyAttributesInput(beds, baths, halfBaths, lotSize, livingArea) {
  if (beds !== undefined && baths !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              baths: baths,
              beds: beds,
              halfBaths: halfBaths,
              livingArea: livingArea,
              lotSize: lotSize
            }
          };
  } else {
    return {
            TAG: "Error",
            _0: "error making singleFamilyAttributes"
          };
  }
}

function makeCondoAttributesInput(beds, baths, halfBaths, lotSize, livingArea) {
  if (beds !== undefined && baths !== undefined) {
    return {
            TAG: "Ok",
            _0: {
              baths: baths,
              beds: beds,
              halfBaths: halfBaths,
              livingArea: livingArea,
              lotSize: lotSize
            }
          };
  } else {
    return {
            TAG: "Error",
            _0: "error making condoAttributesInput"
          };
  }
}

function make(propertyType, beds, baths, halfBaths, lotSize, livingArea) {
  if (propertyType === "CONDO") {
    return Core__Result.map(makeCondoAttributesInput(beds, baths, halfBaths, lotSize, livingArea), (function (condo) {
                  return {
                          condo: condo
                        };
                }));
  } else {
    return Core__Result.map(makeSingleFamilyAttributesInput(beds, baths, halfBaths, lotSize, livingArea), (function (singleFamily) {
                  return {
                          singleFamily: singleFamily
                        };
                }));
  }
}

var Schema;

exports.Schema = Schema;
exports.makeSingleFamilyAttributesInput = makeSingleFamilyAttributesInput;
exports.makeCondoAttributesInput = makeCondoAttributesInput;
exports.make = make;
/* No side effect */
